import React, { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { Table } from "../tables/table";
import { API_URL } from "../../config";
import translate from "../../providers/i18n/translate";
import { Link } from "react-router-dom";
import axios from "axios";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const Root = styled.div`
  width: 100%;
  padding: 10px;
`;

const Title = styled.h3`
  text-transform: uppercase;
  color: ${(props) => props.theme.palette.accent};
  font-size: 1.2rem;
  font-weight: 800;
  margin-bottom: 10px;
`;

const LinkContainer = styled.div`
  display: flex;
  align-items: center;

  a {
    display: flex;
    align-items: center;
    margin-left: 8px;
  }
`;

const TableContainer = styled.div`
  max-height: 400px;
  height: 400px;
  border: 1px solid ${(props) => props.theme.palette.accent};
  border-radius: 0.5rem;
  overflow: hidden;
  margin-bottom: 20px;
`;

const ChildrenTable = () => {
  const { id } = useParams();
  const tableRef = React.useRef();
  const [horse, setHorse] = useState(null);

  useEffect(() => {
    axios
      .get(`${API_URL}/horses/${id}`)
      .then((response) => {
        setHorse(response.data);
      })
      .catch((error) => {
        console.error("Error fetching horse data:", error);
      });
  }, [id]);

  const columns = useMemo(() => {
    const baseColumns = [
      {
        title: translate("name"),
        field: "name",
        order: true,
        render: (rowData) => (
          <LinkContainer>
            {rowData.name}
            <Link to={`/backoffice/horses/${rowData.id}`} target="_blank">
              <OpenInNewIcon fontSize="small" />
            </Link>
          </LinkContainer>
        ),
      },
      {
        title: translate("birthday"),
        field: "dateOfBirth",
        type: "date",
        order: true,
      },
    ];

    if (horse && horse.sex) {
      if (horse.sex.value === "stallion" || horse.sex.value === "castrated" || horse.sex.value === "A Definir") {
        baseColumns.push({
          title: translate("mother"),
          field: "mother.name",
          order: true,
          render: (rowData) =>
            rowData.mother ? (
              <LinkContainer>
                {rowData.mother.name}
                <Link
                  to={`/backoffice/horses/${rowData.mother.id}`}
                  target="_blank"
                >
                  <OpenInNewIcon fontSize="small" />
                </Link>
              </LinkContainer>
            ) : (
              translate("unknown")
            ),
        });
      } else if (horse.sex.value === "mare" || horse.sex.value === "A Definir") {
        baseColumns.push({
          title: translate("father"),
          field: "father.name",
          order: true,
          render: (rowData) =>
            rowData.father ? (
              <LinkContainer>
                {rowData.father.name}
                <Link
                  to={`/backoffice/horses/${rowData.father.id}`}
                  target="_blank"
                >
                  <OpenInNewIcon fontSize="small" />
                </Link>
              </LinkContainer>
            ) : (
              translate("unknown")
            ),
        });
      }
    }

    return baseColumns;
  }, [horse]);

  console.log(horse);

  return (
    <Root>
      <Title>{translate("children")}</Title>
      <TableContainer>
       <Table
        ref={tableRef}
        columns={columns}
        viewTable="list"
        emptyMessage={translate("no children")}
        options={{
          exportButton: false,
          pagination: true,
          pageSize: 10,
          pageSizeOptions: [10, 20, 50, 100],
        }}
        data={(query) =>
          new Promise((resolve, reject) => {
            axios
              .get(`${API_URL}/horses/${id}/children`, {
                params: {
                  page: query.page - 1,
                  limit: query.pageSize,
                  order: query.order,
                },
              })
              .then((response) => {
                resolve(response.data);
              })
              .catch((error) => {
                console.log(error);
                reject(error);
              });
          })
        }
      />
       
      </TableContainer>
    <div style={{ height: "30px" }} />
    </Root>
  );
};

export default ChildrenTable;
